import { defineComponent as _defineComponent } from 'vue'
import bugsnagClient from 'JS/global/bugsnag';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import ExternalAuthLogin from 'JS/components/side-menus/account-creation/components/ExternalAuthLogin.vue';
import ForgotPasswordPage from 'JS/components/side-menus/account-creation/components/ForgotPasswordPage.vue';
import FullScreenLoader from 'JS/components/FullScreenLoader.vue';
import HorizontalTextDivider from 'JS/components/HorizontalTextDivider.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { BButtonSubmitButton, BForm, BTextField } from 'JS/components/blain-form';
import { computed, onBeforeMount, ref } from 'vue';
import { objectToQueryString } from 'JS/utilities/url';
import { provideServices, serviceRegistry } from 'JS/components/side-menus/composables/services';
import { useMediaQuery } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyPassword',
  props: {
    firstName: null,
    email: null,
    destinationUrl: null,
    hasPassword: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	firstName: string,
	email: string,
	destinationUrl: string,
	hasPassword: boolean
}

const { accountService } = serviceRegistry;
provideServices();



const password = ref<string>('');
const errorMessage = ref<string>('');
const showForgotPassword = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const isTabletAndUp = useMediaQuery("(min-width: 479px)");
//AntiForgeryToken comes from VerifyPassword.cshtml
const antiForgeryToken = (
	document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement
).value;

const logoutLink = computed((): string => {
	const loginLink = `/account/login/?${objectToQueryString({
		refUrl: props.destinationUrl,
	})}`;

	return `/account/logout/?${objectToQueryString({
		refUrl: loginLink,
	})}`;
});

function handleSignedIn() {
	window.location.href = props.destinationUrl;
}

async function handleSubmit() {
	try {
		isLoading.value = true;
		const result = await accountService.verifyPassword(password.value, antiForgeryToken);
		if (!result) {
			errorMessage.value = "<span class='bold'>Something went wrong.</span> Please try again later.";
			isLoading.value = false;
			bugsnagClient.notify(new Error("Something went wrong attempting to verify a users password"));
		} else if (!result.success) {
			if (result.requireLogin) {
				window.location.href = logoutLink.value;
			} else {
				errorMessage.value = "<span class='bold'>Invalid Login</span> — Please try again";
				isLoading.value = false;
			}
		} else {
			handleSignedIn();
		}
	} catch (err) {
		errorMessage.value = "<span class='bold'>Something went wrong.</span> Please try again later.";
		isLoading.value = false;
		bugsnagClient.notify(err);
	}
}

onBeforeMount(() => {
	if (!props.email) window.location.href = logoutLink.value;
});


return { __sfc: true,accountService, props, password, errorMessage, showForgotPassword, isLoading, isTabletAndUp, antiForgeryToken, logoutLink, handleSignedIn, handleSubmit, ErrorBanner, ExternalAuthLogin, ForgotPasswordPage, FullScreenLoader, HorizontalTextDivider, LinkButton, BButtonSubmitButton, BForm, BTextField }
}

})